<div *ngIf="this.tooltipValue">
    <span *ngIf="this.fndFormats">
        <mat-icon class="svgIconValue" #fmtTip="matTooltip" [matTooltip]="tooltipText"
            matTooltipClass="value-icon-tip" matTooltipPosition="below" matTooltipTouchGestures="on"
            (click)="fmtTip.toggle()" [aria-hidden]="true" [svgIcon]="fndFormats.icon"
            [style.color]="fndFormats.color"></mat-icon>
    </span>
    <span *ngIf="!this.fndFormats">
        <mat-icon class="svgIconValue" #nullTip="matTooltip" [matTooltip]="tooltipText"
            matTooltipClass="value-icon-tip" matTooltipPosition="below" matTooltipTouchGestures="on"
            (click)="nullTip.toggle()" [aria-hidden]="true" [svgIcon]="fixNull"></mat-icon>
    </span>
</div>
<div *ngIf="!this.tooltipValue">
    <span *ngIf="this.fndFormats">
        <mat-icon class="svgIconValue" [aria-hidden]="true"  [svgIcon]="fndFormats.icon" [style.color]="fndFormats.color"></mat-icon>
    </span>
    <span *ngIf="!this.fndFormats">
        <mat-icon class="svgIconValue" [aria-hidden]="true" [svgIcon]="fixNull"></mat-icon>
    </span>
</div>
